export default __webpack_public_path__ + "static/media/faq_header_logo.38ece733.png";